import React from 'react';
import { getAtlasVersion } from '../lib/version';
interface VersionStampProps {
  prefix?: string;
}
export function VersionStamp({
  prefix = 'Quad Atlas'
}: VersionStampProps) {
  const v = getAtlasVersion();
  return <span className="text-xs text-slate-500 opacity-70 font-sans" data-id="element-1532">
      {prefix} • {v}
    </span>;
}